<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Fabricantes</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Nome Fabricante</mat-label>
                    <input matInput formControlName="nomeFabricante" type="nomeFabricante" readonly>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Versão 1.1.1</mat-label>
                    <input matInput formControlName="versao" type="text">
                    <mat-icon class="material-icons-outlined" matSuffix matTooltip="Versão da tinta importada">info_outline</mat-icon>
                    @if (model.get('versao')?.invalid) {
                        <mat-error>Informe a versão</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="row">

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Versão Resulth 29.02aa(0)</mat-label>
                    <input matInput formControlName="versaoResulth" type="text">
                    <mat-icon class="material-icons-outlined" matSuffix matTooltip="Versão a partir da qual o Resulth Windows poderá importar os dados">info_outline</mat-icon>
                    @if (model.get('versaoResulth')?.invalid) {
                      <mat-error>Informe a versão do Resulth</mat-error>
                  }
                </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Data/Hora</mat-label>
                    <input matInput formControlName="dataHora" type="text" readonly>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>Usuário Administrador</mat-label>
                <input matInput formControlName="usuarioAdministriador" type="text" readonly>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 d-flex content-arquivo">
            <button type="button" mat-flat-button type="button" class="btn-primary" (click)="filePicker.click()">
              Selecionar arquivo
            </button>
            <mat-label class="arquivo-nome" [title]="fileName">{{fileName}}</mat-label>
            <input type="file" #filePicker (change)="selecionaArquivo($event)" accept=".rar" hidden>
          </div>
          @if (model.get('arquivo')?.invalid) {
            <mat-error>Selecione o arquivo no formato .rar</mat-error>
        }
        </div>

        <div class="row">
          <div class="col-md-6 image-container responsive-container">
            <mat-label class="subtitle-default">Imagem</mat-label>
            @if(_fabricanteResponse && _fabricanteResponse.fabricante.urlImagem){
              <img
                [src]="this._fabricanteResponse.fabricante.urlImagem"
                alt="fabricante-imagem"
                class="image-preview"
              >
            }
          </div>
          <div class="col-md-6 d-flex tabela-container responsive-container">
            <mat-label class="subtitle-default">Tabelas</mat-label>
            <div class="tabelas">
              <button type="button" mat-flat-button type="button" class="btn-primary button-big tabela-button" (click)="abreModalBase()">
                Bases
              </button>
              <button type="button" mat-flat-button type="button" class="btn-primary button-big tabela-button" (click)="abreModalPigmento()">
                Pigmentos
              </button>
              <button type="button" mat-flat-button type="button" class="btn-primary button-big tabela-button" (click)="abreModalEmbalagem()">
                Embalagens
              </button>
              <button type="button" mat-flat-button type="button" class="btn-primary button-big tabela-button" (click)="abreModalCor()">
                Cores
              </button>
              <button type="button" mat-flat-button type="button" class="btn-primary button-big tabela-button" (click)="abreModalFormula()">
                Fórmulas
              </button>
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-md-3 responsive-container">
                <button type="submit" mat-flat-button class="btn-primary button-big">
                    @if (_isLoading === true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                    }
                    @else{
                        Salvar
                    }
                </button>
            </div>
        </div>
    </form>
</div>
